module.exports = __webpack_public_path__ + "img/before920.07282536.jpg";